import React from 'react';
import clsx from 'clsx';

const CashinClosingOddsIcon = ({ width, height }) => (
    <svg className={clsx('icon cashin-closing-odds-icon portal')} width={width} height={height} viewBox="0 0 20 20">
        <path d="M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0zm4.375 11.363c0 2.352-1.961 4.262-4.375 4.262s-4.375-1.912-4.375-4.262v-4.8a.938.938 0 0 1 1.876 0v4.801c0 1.316 1.121 2.387 2.5 2.387s2.5-1.071 2.5-2.386V6.563a.938.938 0 0 1 1.876 0v4.801z" />
    </svg>
);

export default CashinClosingOddsIcon;
